import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20dim%20office%20corridor%20at%20night%20with%20a%20single%20desk%20lamp%20glowing%20through%20glass%2C%20empty%20chairs%2C%20cinematic%20moody%20atmosphere%2C%20no%20people%2C%20editorial%20photography%2C%20deep%20amber%20and%20brown%20tones&width=1600&height=700&seq=cta-zhijing-01&orientation=landscape"
        alt="夜晚的办公走廊与亮着的台灯，象征仍在整理线索的编辑部"
        className="absolute inset-0 h-full w-full object-cover object-top opacity-35"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/78 to-foreground-950/60" />

      <div className="relative mx-auto max-w-content px-4 py-16 text-center md:px-6 md:py-24">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/15 px-3.5 py-1.5 font-label text-xs tracking-[0.2em] text-primary-100">
          匿名投稿通道
        </span>
        <h2 className="mx-auto mt-5 max-w-2xl font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl">
          有线索，或者正在经历类似的事？
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
          把你知道的细节告诉我们。每一条线索都会被认真对待，涉及个人身份的信息在发布前都会做脱敏处理。
        </p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            to="/contact"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            前往投稿
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap rounded-md border border-background-300/40 px-6 py-3.5 font-label text-sm font-medium text-background-100 transition-colors hover:bg-background-50/10"
          >
            了解我们的原则
          </Link>
        </div>
      </div>
    </section>
  );
}